ko.components.register('user-events-subscriptions-editor', {
	viewModel: function(opts) {
		var self = this;

		self.loading = ko.observable(false);

        self.types = ko.observableArray();
        self.typesSelected = ko.observableArray();

		self.data = ko.observable();

        self.setData = function(data){
            self.types.removeAll();
        	for(var k in data) {
                if(!data.hasOwnProperty(k))
                    continue;
                self.types.push(new DomainEventType(data[k]));
            }
            self.data(ko.toJSON(self.getData()));
        };

		self.getData = function(){
			var data = [];
			$.each(self.types().filter(function(item){ return item.selected(); }), function(){
            	data.push(this.type());
			});
			return data;
		};

		self.hasChanges = ko.computed(function(){
			return (self.data() !== ko.toJSON(self.getData()));
		});

		self.toggleAll = function(){
            $.each(self.types(), function(){
                this.toggleSelection();
            });
		};

		self.saveChanges = function(){
			if(self.loading())
				return;
			self.loading(true);
			var json = ko.toJSON(self.getData());
			$.ajax({
				type: 'post',
				data: $.extend({ 'subscriptions': json }, App.csrf||{}),
				dataType: 'json',
				complete: function(){ self.loading(false); },
				success: function(r){
					if(r) {
						if(r.ok)
							self.data(json);
						else if(r.error)
							alert(r.error);
					}
				}
			});
		};

        self.setData(opts.types || []);
	},
	template: "<div class=\"user-events-subscriptions\">\n\t<h5 class=\"mb-2\">Subscriptions\n\t\t<button class=\"btn btn-outline-secondary btn-sm ml-3\" data-bind=\"click: toggleAll\">Toggle All</button>\n\t\t<button class=\"btn btn-primary btn-sm ml-1\" data-bind=\"visible: hasChanges(), disabled: loading, click: saveChanges\">Save Subscriptions</button>\n\t</h5>\n\t<table class=\"w-100\" data-bind=\"foreach: types\">\n\t\t<tr class=\"event-subscription\" data-bind=\"css: { 'active': selected() }, click: toggleSelection\">\n\t\t\t<td class=\"i\">\n\t\t\t\t<span class=\"ic ic-ok\" data-bind=\"visible: selected()\"></span>\n\t\t\t\t<span class=\"ic ic-remove\" data-bind=\"visible: !selected()\"></span>\n\t\t\t</td>\n\t\t\t<td data-bind=\"text: label()\"></td>\n\t\t</tr>\n\t</table>\n</div>"
});
